
export const isValidEmail = (email, callback) => {
    const valid = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/).test(email);
    if (callback && valid) {
        callback();
    }
    return valid;
}

export const URI_API = "http://190.131.221.172:3000"
export const URI_WS = "ws://190.131.221.172:3000"

// DEV
// export const URI_API = "http://192.168.1.3:3000"
// export const URI_WS = "ws://192.168.1.3:3000"

// LOCAL
// export const URI_API = "http://localhost:4001"
// export const URI_WS = "ws://localhost:4001"

// export const URI_API = "http://192.168.1.53:4001"
// export const URI_WS = "ws://192.168.1.53:4001"